module.exports = __webpack_public_path__ + "media/home/wsj-74f2e158.png";